module.exports = __webpack_public_path__ + "img/开放平台bg@2x.4ef05140.png";